module.exports = __webpack_public_path__ + "img/20190917173917325.f60d7ff9.jpg";